"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterStyledSystemMarginProps;

var _filterObjectProperties = _interopRequireDefault(require("../../utils/helpers/filter-object-properties"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const marginPropertyNames = ["margin", "m", "marginLeft", "ml", "marginRight", "mr", "marginTop", "mt", "marginBottom", "mb", "marginX", "mx", "marginY", "my"];

function filterStyledSystemMarginProps(originalObject) {
  return (0, _filterObjectProperties.default)(originalObject, marginPropertyNames);
}